// extracted by mini-css-extract-plugin
export default {"section":"section__vQrBo","green":"green__IthFx"};